import { MoreHorizontal } from 'lucide-react'
import { cn } from '@/utils/cn'
import type { Bloco, BlocoKanbanColumn } from '@/types/bloco'
import { TarefasKanbanCard } from './TarefasKanbanCard'

interface TarefasKanbanColumnProps {
  column: BlocoKanbanColumn
  items: Bloco[]
  currentUserId?: string
  draggedBlocoId: string | null
  isDragOver: boolean
  onDragOver: (e: React.DragEvent) => void
  onDragEnter: (e: React.DragEvent, columnId: string) => void
  onDragLeave: (e: React.DragEvent, columnId: string) => void
  onDrop: (e: React.DragEvent, columnId: string) => void
  onDragStart: (e: React.DragEvent, blocoId: string) => void
  onDragEnd: () => void
  onOpen: (id: string) => void
}

export function TarefasKanbanColumn({
  column,
  items,
  currentUserId,
  draggedBlocoId,
  isDragOver,
  onDragOver,
  onDragEnter,
  onDragLeave,
  onDrop,
  onDragStart,
  onDragEnd,
  onOpen,
}: TarefasKanbanColumnProps) {
  return (
    <div className='flex w-72 shrink-0 flex-col'>
      <div className='mb-2 flex items-center gap-2 rounded-lg border border-[var(--glass-border)] bg-bg-card/90 px-3 py-2 shadow-sm'>
        <span
          className='h-2.5 w-2.5 shrink-0 rounded-full'
          style={{ backgroundColor: column.accent }}
          aria-hidden
        />
        <span className='min-w-0 flex-1 truncate text-sm font-medium text-text-primary'>{column.name}</span>
        <span className='shrink-0 rounded-md bg-[var(--glass-bg)] px-2 py-0.5 text-xs font-semibold text-text-muted'>
          {items.length}
        </span>
        <button
          type='button'
          className='shrink-0 rounded p-1 text-text-muted hover:bg-[var(--glass-bg)] hover:text-text-primary'
          aria-label={`Opções da coluna ${column.name}`}
        >
          <MoreHorizontal size={16} />
        </button>
      </div>

      <div
        onDragOver={onDragOver}
        onDragEnter={(e) => onDragEnter(e, column.id)}
        onDragLeave={(e) => onDragLeave(e, column.id)}
        onDrop={(e) => onDrop(e, column.id)}
        className={cn(
          'min-h-[200px] flex-1 space-y-2 rounded-lg border border-[var(--glass-border)] bg-[var(--glass-bg)]/50 p-2 transition-colors',
          draggedBlocoId && 'border-dashed',
          isDragOver && 'border-[var(--brand-primary)]/50 bg-[var(--brand-primary)]/5',
        )}
      >
        {items.length === 0 ? (
          <p className='px-2 py-6 text-center text-xs text-text-muted'>Nenhuma tarefa</p>
        ) : (
          items.map((bloco) => (
            <TarefasKanbanCard
              key={bloco.id}
              bloco={bloco}
              currentUserId={currentUserId}
              isDragging={draggedBlocoId === bloco.id}
              onOpen={onOpen}
              onDragStart={onDragStart}
              onDragEnd={onDragEnd}
            />
          ))
        )}
      </div>
    </div>
  )
}
